module.exports = __webpack_public_path__ + "static/m_solution7-2b541b988330546ef582dec3e0f3b3b9.png";